module.exports = __webpack_public_path__ + "media/28.fee2227b.wav";